import gql from "graphql-tag";

export const allFields = gql`
	fragment SubscriptionAllFields on Subscription {
		subscriptionID
		expirationDate
		allowedActivations
		status
		isAutoBillingEnabled
		serialNumbers {
			licenseName
			serialNumber
			usedActivations
			activations {
				id
				status
				version
				activated
				deactivated
				computerName
			}
		}
		plan {
			name
			planCode
		}
		isTrial
		lastOrder {
			orderNumber
			isSerialNumberGenerationPending
		}
	}
`;
